import React from 'react';

export const Button=({
  className,
  children,
  text = '',
  type = 'button',
  title='',
  id = '',
  disabled,
  clickHandler = () => {},
})=> {
  return (
    <button className={className} title={title} onClick={clickHandler} type={type} id={id} disabled={disabled}>
      {text ? text : children}
    </button>
  );
}

